<script setup lang="ts">
import { useControlValidation } from "@/composables/use-control-validation";
import type { UserDTO } from "@/models/dtos/user-dto";
import { Role } from "@/models/enums/role";
import type { CreateUserRequest } from "@/models/requests/create-user-request";
import { getCreateUserSchema } from "@/schemas/create-user-schema";
import { usersService } from "@/services/users-service";
import ControlValidation from "./control-validation.vue";
import { notificationsService } from "@/services/notifications-service";
import { ref, toRefs } from "vue";

const props = defineProps<{
  customerNumber: string;
  role: Role;
}>();
const { customerNumber, role } = toRefs(props);

const emit = defineEmits<{
  (e: "create", user: UserDTO): void;
}>();

function getDefaultFormData(): CreateUserRequest {
  return {
    name: "",
    phone: "",
    email: "",
    customerNumber: customerNumber.value,
    role: role.value,
  };
}

const loading = ref(false);
const formData = ref(getDefaultFormData());

const { result, validate } = useControlValidation(() => getCreateUserSchema());

async function onCreate() {
  loading.value = true;

  try {
    const valid = validate(formData.value);
    if (!valid) return;

    const created = await usersService.createUser(formData.value);
    notificationsService.open({
      text: "Användare skapad.",
      type: "success",
    });
    emit("create", created);
  } catch (error) {
    notificationsService.open({
      text: "Något gick fel vid skapning av användare.",
      type: "error",
      error,
    });
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <form @submit.prevent="onCreate">
    <!--    <div class="field">-->
    <!--      <label class="label" for="username">Användarnamn</label>-->
    <!--      <control-validation :result="result" field="username" #="{ inputClass }">-->
    <!--        <div class="control">-->
    <!--          <input-->
    <!--            id="username"-->
    <!--            v-model="formData.username"-->
    <!--            class="input"-->
    <!--            type="text"-->
    <!--            name="username"-->
    <!--            :class="inputClass"-->
    <!--          />-->
    <!--        </div>-->
    <!--      </control-validation>-->
    <!--    </div>-->

    <div class="field">
      <label class="label" for="name">Namn</label>
      <control-validation :result="result" field="name" #="{ inputClass }">
        <div class="control">
          <input
            id="name"
            v-model="formData.name"
            class="input"
            type="text"
            name="name"
            :class="inputClass"
          />
        </div>
      </control-validation>
    </div>

    <div class="field">
      <label class="label" for="phone">Telefonnummer</label>
      <control-validation :result="result" field="phone" #="{ inputClass }">
        <div class="control">
          <input
            id="phone"
            v-model="formData.phone"
            class="input"
            type="tel"
            name="phone"
            :class="inputClass"
          />
        </div>
      </control-validation>
    </div>

    <div class="field">
      <label class="label" for="email">E-post</label>
      <control-validation :result="result" field="email" #="{ inputClass }">
        <div class="control">
          <input
            id="email"
            v-model="formData.email"
            class="input"
            type="email"
            name="email"
            :class="inputClass"
          />
        </div>
      </control-validation>
    </div>

    <!--    <div class="field">-->
    <!--      <label class="label" for="name">Lösenord</label>-->
    <!--      <control-validation :result="result" field="password" #="{ inputClass }">-->
    <!--        <div class="control">-->
    <!--          <input-->
    <!--            id="password"-->
    <!--            v-model="formData.password"-->
    <!--            class="input"-->
    <!--            type="password"-->
    <!--            name="password"-->
    <!--            :class="inputClass"-->
    <!--          />-->
    <!--        </div>-->
    <!--      </control-validation>-->
    <!--    </div>-->

    <!--    <div class="field">-->
    <!--      <label class="label" for="passwordRepeated">Upprepa lösenord</label>-->
    <!--      <control-validation :result="result" field="passwordRepeated" #="{ inputClass }">-->
    <!--        <div class="control">-->
    <!--          <input-->
    <!--            id="passwordRepeated"-->
    <!--            v-model="formData.passwordRepeated"-->
    <!--            class="input"-->
    <!--            type="password"-->
    <!--            name="passwordRepeated"-->
    <!--            :class="inputClass"-->
    <!--          />-->
    <!--        </div>-->
    <!--      </control-validation>-->
    <!--    </div>-->

    <div class="control">
      <button
        class="button is-primary"
        type="submit"
        :class="{ 'is-loading': loading }"
      >
        Skapa
      </button>
    </div>
  </form>
</template>
